import memoize from 'lodash/memoize';
import { STORAGE_KEYS } from 'constants.js';

export function setTokenAsCacheKey() {
  return (
    sessionStorage.getItem(STORAGE_KEYS.EMULATION_TOKEN) ??
    sessionStorage.getItem(STORAGE_KEYS.TOKEN) ??
    new Date().getTime()
  );
}

export const setTokenAndParamsAsCacheKey = (params) => {
  const token = sessionStorage.getItem(STORAGE_KEYS.TOKEN) ?? new Date().getTime();
  return `${JSON.stringify(params)}${token}`;
};

export function memoizeWithToken(request) {
  return memoize(request, setTokenAsCacheKey);
}

// Explicitly pass in a unique id to generate a memoization key
export const memoizeWithUidAndParams = (uid) => (fn) =>
  memoize(fn, (params) => `${JSON.stringify(params)}${uid}`);

// Use token from session storage to create a memoization key
export function memoizeWithTokenAndParams(request) {
  return memoize(request, setTokenAndParamsAsCacheKey);
}

export default setTokenAsCacheKey;
